import { render, staticRenderFns } from "./SalesReportActionResetQuery.vue?vue&type=template&id=16bc1b42&"
import script from "./SalesReportActionResetQuery.vue?vue&type=script&lang=ts&"
export * from "./SalesReportActionResetQuery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports